module.exports = __webpack_public_path__ + "static/media/max-bet.d04f11c9.png";